import { Checkbox, DataSource, ExcludableTextbox, Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalespersonReassignmentReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludableTextboxProspectTypeId: ExcludableTextbox;
    excludableTextboxSalesStatusId: ExcludableTextbox;
    excludabletextboxCustomerId: ExcludableTextbox;
    excludabletextboxSalesManagerId: ExcludableTextbox;
    excludabletextboxSalespersonId: ExcludableTextbox;
    labelPercentage: Label;
    sourceSalespersonReassignmentReport: DataSource;
    textboxDaysRemaining: Textbox;
    textboxGroupBy: Textbox;
    textboxMetricAmount: Textbox;
    textboxMetricType: Textbox;
    textboxReassignProfileId: ExcludableTextbox;
    textboxSelectType: Textbox;
    textboxSortBy: Textbox;
}
